import api from './api';

export const pageService = {
  // Get all page
  getAll: async (type = null, includeInactive = false) => {
    const params = {};
    if (type) params.type = type;
    if (includeInactive) params.includeInactive = includeInactive;
    
    const response = await api.get('/page', { params });
    return response.data;
  },

  // Get recent page
  getRecent: async (limit = 5) => {
    const response = await api.get('/page/recent', {
      params: { limit },
    });
    return response.data;
  },

  // Get pinned page
  getPinned: async () => {
    const response = await api.get('/page/pinned');
    return response.data;
  },

  // Search page
  search: async (query) => {
    const response = await api.get('/page/search', {
      params: { q: query },
    });
    return response.data;
  },

  // Get page by ID
  getById: async (id) => {
    const response = await api.get(`/page/${id}`);
    return response.data;
  },

  // Get page by slug
  getBySlug: async (slug) => {
    const response = await api.get(`/page/slug/${slug}`);
    return response.data;
  },

  // Create page (admin)
  create: async (data) => {
    const response = await api.post('/page', data);
    return response.data;
  },

  // Update page (admin)
  update: async (id, data) => {
    const response = await api.put(`/page/${id}`, data);
    return response.data;
  },

  // Delete page (admin)
  delete: async (id) => {
    const response = await api.delete(`/page/${id}`);
    return response.data;
  },
};

export default pageService;
